import PropTypes from 'prop-types';
import React from 'react';
import ReferralRowIcon from 'src/components/Dashboard/components/Referrals/ReferralRowIcon';
import { DynamicTable } from 'common/tables';
import { shapes } from '@unite-us/client-utils';
import { Spinner } from 'common/spinners';
import _ from 'lodash';
import FilterBar from '../FilterBar';

const SERVICE_AUTH_REJECTED_BY = 'Utilization Manager';

function getColumns(setSort, sortConfig) {
  const lastUpdatedColumn = {
    label: 'Last Updated',
    sortColumn: 'updated_at',
    type: 'date',
  };

  if (setSort && sortConfig) {
    lastUpdatedColumn.sortBy = sortConfig?.sidx;
    lastUpdatedColumn.sortDirection = sortConfig?.sord;
    lastUpdatedColumn.setSort = ({ sortBy }) => setSort(sortBy);
  }

  return [
    {
      label: 'Rejected By',
      sortColumn: 'rejected_by',
    },
    {
      label: 'Client Name',
      sortColumn: 'contact.full_name',
    },
    {
      label: 'Service Type',
      sortColumn: 'service_type.name',
    },
    lastUpdatedColumn,
  ];
}

function populateRejectedByField(referrals) {
  return referrals.map((referral) => {
    const rejected_by = referral.state === 'denied_authorization' ?
      (referral?.rejector?.provider?.name || SERVICE_AUTH_REJECTED_BY) : referral.referred_to_group.name;
    return { ...referral, rejected_by };
  });
}

export function RejectedReferralsIndex(props) {
  const {
    paging,
    data,
    onNextClick,
    onPrevClick,
    isFetching,
    onCellClick,
    initialSort,
    filters,
    onFiltersChange,
    fetchGroupsUsers,
    sortConfig,
    setSort,
  } = props;
  return (
    <div>
      <FilterBar
        filters={filters}
        onFiltersChange={onFiltersChange}
        paging={paging}
        onNextClick={onNextClick}
        onPrevClick={onPrevClick}
        isFetching={isFetching && !_.isEmpty(data)}
        asyncSearch={fetchGroupsUsers}
      />
      <div className="dashboard-inner-content">
        {
          (isFetching && _.isEmpty(data)) ?
            <Spinner /> : (
              <DynamicTable
                id="rejected-referrals-table"
                dataSet={populateRejectedByField(data)}
                onCellClick={onCellClick}
                initialSort={initialSort}
                columnLabels={getColumns(setSort, sortConfig)}
                emptyMessage="There are no rejected referrals."
                rowIcon={(referral) => <ReferralRowIcon referral={referral} />}
              />
            )
        }
      </div>
    </div>
  );
}

RejectedReferralsIndex.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  data: PropTypes.array.isRequired,
  paging: shapes.paging,
  onNextClick: PropTypes.func.isRequired,
  onPrevClick: PropTypes.func.isRequired,
  onCellClick: PropTypes.func.isRequired,
  initialSort: PropTypes.object,
  filters: PropTypes.array,
  onFiltersChange: PropTypes.func,
  fetchGroupsUsers: PropTypes.func.isRequired,
  sortConfig: PropTypes.func,
  setSort: PropTypes.object,
};

RejectedReferralsIndex.defaultProps = {
  sortConfig: null,
  setSort: null,
};

export default RejectedReferralsIndex;
